

<div class="row" *ngIf="bool_table">
    <div class="col-md-12">
            <div class="card-body">
                <div class="row pad-tb-10">
                    <div class="col-md-10">
                        <span class="fnt-21">Verify Your Previous Payment History and Proceed for Payment  </span>
                    </div>
                
                    <!-- <div class="col-md-2 align-right">
                        <button class="btn btn-primary" (click)="bcakfn()"> Back </button>
                    </div> -->
                </div>

                                
                <div class="row pad-tb-10">
                    <div class="col-md-4">
                        <span class="fnt-21">Total Candidates Selected: {{studcount}}  </span>
                    </div>
                    <div class="col-md-4">
                        <span class="fnt-21">  Fees Amount: {{totCount}}</span>
                    </div>
                
                </div>

                <div class="row pad-tb-10">
                    <div class="col-md-6">
                        <!-- Name: {{itiHeaderName}} <br>
                        ITI Code: {{itiHeaderCode}} <br>     -->
                    </div>
                    <div class="col-md-6">
                        <!-- Email: {{itiHeaderemail}} <br>
                        Mobile: {{itiHeaderMobile}} <br>     -->
                    </div>
                </div>
                <div class="example-container mat-elevation-z8">
                    <mat-table #table [dataSource]="dataSource_payMaster" #sort_Master="matSort" matSort>

                        <ng-container matColumnDef="selects" class="mat-column-username">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>  
                                Selects 
                            
                        </mat-header-cell>
                            <mat-cell *matCellDef="let element"> 

                              
                                <mat-checkbox *ngIf="element.status == ''" (change)="selectRow($event,element)" 
                                (change)="$event ? selected_family_member_payMaster.toggle(element) : null"
                                [checked]="selected_family_member_payMaster.isSelected(element)">
                        </mat-checkbox>
                            </mat-cell>
                            
                        </ng-container>

                        <ng-container matColumnDef="slno">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> # </mat-header-cell>
                            <mat-cell *matCellDef="let element; let i = index;"> {{i+1}} </mat-cell>
                        </ng-container>
 
                        <ng-container matColumnDef="payrefid">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> PayRefID    </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.payrefid}} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="iticode">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> ITI code </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.iticode}} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="payrefdate">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> PayRefDate </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.payrefdate}} </mat-cell>
                        </ng-container>

                        <!-- Position Column -->
                        <ng-container matColumnDef="noofstu">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Students </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.noofstu}} 
                                <!-- <button class="btn btn-success small-btn" (click)="selected_family_member_payMaster.select(element)" (click)="payMasterView()">View</button>  -->
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="amount">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Amount    </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.amount}} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="ccaveref">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> CCRefNo </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.ccaveref}} </mat-cell>
                        </ng-container>

                        <!-- Position Column -->
                        <ng-container matColumnDef="paymentdate">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Payment Date </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.paymentdate}} </mat-cell>
                        </ng-container>                

                        <!-- Position Column -->
                        <ng-container matColumnDef="pstatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
                            <mat-cell *matCellDef="let element"> 
                                <!-- <button class="btn btn-success small-btn" *ngIf="element.status == ''" (click)="selected_family_member_payMaster.select(element)"  (click)="payMaster()"> {{element.status }}Pay</button>                                 -->
                                <span class="btn btn-success small-btn"  *ngIf="element.status == 'DONE' ">PAID</span>
                                <span class="btn btn-primary small-btn" *ngIf="element.status == 'pending'">Pending</span>

                            <!-- <button class="btn btn-danger small-btn" *ngIf="element.pstatus == ''" (click)="selected_family_member_payMaster.select(element)"  (click)="payMasterCancel()"> Cancel </button> -->


                                </mat-cell>
                        </ng-container>       

       

                        <mat-header-row *matHeaderRowDef="displayedColumnspayMaster"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumnspayMaster;  let i = index"></mat-row>

                    </mat-table>
                    <!-- <mat-paginator #paginator_Master="matPaginator"  [length]="totallength_master" [pageSizeOptions]="[ 5,10, 25]"></mat-paginator> -->

                </div>
                <div class="row pad-tb-10">
     
                    <!-- <div class="col-md-12 align-right">
                        <button class="btn btn-success small-btn" [disabled]="bool_paynow"  (click)="offln_form_fn()"> Pay Offline </button>
                    </div> -->
                    <p> Before selecting paynow Kindly ensure  that the candidate selected are correct. After selecting paynow changes in selected candidates cannot be made</p>
        
                </div>
            </div>
    </div>
</div>

<div class="row" *ngIf="bool_offline_form">
    <div class="col-md-12">
        
        <div class="card-body" >
 

          <form [formGroup]="nimiForm" (ngSubmit)="onnimiSubmit()">
            <div class="form-row">
              
                <div class="form-group col-4">
                    <label>Payment Mode <span class="clr_red"> * </span></label>

                    <select formControlName="paymode" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.paymode.errors }"
                        >
                        <option [selected]="true" value="" [disabled]="true">Select Pay mode
                        </option>
                        <option value="Demand Draft">Demand Draft</option>
                        <option value="RTGS">RTGS</option>
                        <option value="Bank Deposit">Bank Deposit</option>
                        <option value="Account Transfer">Account Transfer</option>
                    </select>
                    <div *ngIf="submitted && f.paymode.errors" class="invalid-feedback">
                        <div *ngIf="f.paymode.errors.required">Select Your Pay mode</div>
                    </div>
                </div>

                <div class="form-group col-4">
                  <label>Reference Number <span class="clr_red"> * </span></label>
                  <input type="text" formControlName="refno" class="form-control"
                      [ngClass]="{ 'is-invalid': submitted && f.refno.errors }" maxlength="20"
                      placeholder="Enter Your Reference Number" (keypress)="omit_spl($event)" />
                  <div *ngIf="submitted && f.refno.errors" class="invalid-feedback">
                      <div *ngIf="f.refno.errors.required">Enter Your Reference Number</div>
                  </div>
              </div>

              <div class="form-group col-4">
                <label>ITI code list <span class="clr_red"> * </span></label>
                <input type="text" formControlName="iticode" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.amount.errors }" maxlength="1000"
                    placeholder="Enter Your ITI Code" [(ngModel)]="Iticount" (keypress)="omit_number($event)" readonly />
                <div *ngIf="submitted && f.iticode.errors" class="invalid-feedback">
                    <div *ngIf="f.iticode.errors.required">Enter Your ITI Code</div>
                </div>
            </div>


              <div class="form-group col-4">
                <label>Amount <span class="clr_red"> * </span></label>
                <input type="text" formControlName="amount" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.amount.errors }" maxlength="50"
                    placeholder="Enter Your Amount" [(ngModel)]="totCount" (keypress)="omit_number($event)" readonly />
                <div *ngIf="submitted && f.amount.errors" class="invalid-feedback">
                    <div *ngIf="f.amount.errors.required">Enter Your Amount</div>
                </div>
            </div>

            <div class="form-group col-4">
                <label>Date <span class="clr_red"> * </span></label>
                <input type="date" formControlName="date" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.date.errors }" maxlength="50"
                    placeholder="Enter Your Date" (keypress)="omit_spl($event)" />
                <div *ngIf="submitted && f.date.errors" class="invalid-feedback">
                    <div *ngIf="f.date.errors.required">Enter Your Date</div>
                </div>
            </div>

            <div class="form-group col-4">
                <label>State <span class="clr_red"> * </span></label>

                <input type="text" formControlName="state" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.state.errors }" maxlength="50"
                    placeholder="Enter Your State Name" [(ngModel)]="reciveeITIStateName" readonly />

                <!-- <select formControlName="state" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
                    <option [selected]="true" value="" [disabled]="true">Select District
                    </option>
                    <option *ngFor="let country of state" [value]="country.statename">
                        {{ country.statename }}
                    </option>
                </select> -->
                <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                    <div *ngIf="f.state.errors.required">Enter Your State</div>
                </div>
            </div>

         
               

            </div>
            <hr>
            <div class="form-row">
                <div class="form-group col-12">
                    <div class="text-center">
                        <button [disabled]="bool_offln_submit" class="btn btn-primary mr-1">Submit</button>
                    </div>
                    <!-- <div *ngIf="bool_spinner" class="bg-overlay_cls">
                      Please Wait...
                      </div> -->
                </div>
            </div>
        </form>

        </div>
    </div>
</div>